<template>
  <div class="product-container">
    <div class="product-header">
      <h1 class="main-title">小微企业贷款产品</h1>
      <p class="sub-title">助力小微企业发展，提供多样化融资解决方案</p>
    </div>
    <!-- 产品列表展示区域 -->
    <div class="product-list">
      <!-- 无产品时显示的内容 -->
      <div v-if="productList.length == 0" class="no-product">
        <i class="el-icon-document"></i>
        <p>暂无产品信息</p>
        <p class="sub-tip">请稍后再来查看，或联系客服了解更多信息</p>
      </div>
      <!-- 使用v-for循环渲染产品卡片 -->
      <div
        v-else
        class="product-card"
        v-for="item in productList"
        :key="item._id"
      >
        <div class="product-info">
          <div class="product-title">
            <h2>{{ item.name }}</h2>
          </div>
          <div class="product-features">
            <div class="feature-item">
              <div class="feature-label">最长期限</div>
              <div class="feature-value">{{ item.maxTerm }}年</div>
            </div>
            <div class="feature-item">
              <div class="feature-label">最高额度</div>
              <div class="feature-value">{{ item.maxAmount }}万元</div>
            </div>
          </div>
          <div class="product-desc">
            {{ item.targets }}
          </div>
          <div class="product-actions">
            <el-button
              type="success"
              class="apply-btn"
              @click="handleApply(item)"
              >立即申请</el-button
            >
            <a class="detail-link" @click="viewDetail(item)"
              >查看详情 <i class="el-icon-arrow-right"></i
            ></a>
          </div>
        </div>
      </div>
      <!-- 加载中显示 -->
      <div v-if="loading" class="loading-container">
        拼命加载中...
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// 导入API接口函数
import { getInfo } from "@/api";
export default {
  name: "Product", // 组件名称
  data() {
    return {
      productList: [], // 产品列表数据
      total: 0, // 产品总数
      loading: false, // 加载状态
      currentPage: 1, // 当前页码
      pageSize: 20, // 每页显示数量
    };
  },
  methods: {
    // 处理每页显示数量变化
    handleSizeChange(val) {
      this.pageSize = val; // 更新每页显示数量
      this.getProductList(); // 重新获取产品列表
    },
    // 处理页码变化
    handleCurrentChange(val) {
      this.currentPage = val; // 更新当前页码
      this.getProductList(); // 重新获取产品列表
    },
    // 处理产品申请
    handleApply(item) {
      // 获取用户登录状态
      let access_token = localStorage.getItem("access_token");
      let isUserAuth = localStorage.getItem("isUserAuth");
      // 判断用户是否已登录
      if (access_token && isUserAuth) {
        // 已登录，跳转到申请页面
        this.$router.push({
          path: `/apply/` + item._id, // 带上产品ID
        });
      } else {
        // 未登录，提示用户并跳转到登录页面
        this.$message({
          message: "请先登录账号进行产品申请！",
          type: "warning",
        });
        this.$router.push({
          path: "/login",
        });
      }
    },
    // 查看产品详情
    viewDetail(item) {
      let id = item._id; // 获取产品ID
      // 跳转到产品详情页
      this.$router.push({
        path: `/productdetail/` + id,
      });
    },
    // 获取产品列表数据
    getProductList() {
      this.loading = true; // 设置加载状态为true
      // 从后端获取数据
      getInfo({
        model: "product", // 模型名称
        condition: {}, // 查询条件
        page: this.currentPage, // 当前页码
        pagesize: this.pageSize, // 每页显示数量
      }).then((res) => {
        if (res.status == 200) {
          this.productList = res.data.data; // 设置产品列表数据
          this.total = res.data.page_info.total_size; // 设置产品总数
          this.loading = false; // 设置加载状态为false
        }
      });
    },
  },
  // 组件创建时执行
  created() {
    this.getProductList(); // 获取产品列表数据
  },
};
</script>

<style scoped>
.product-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  position: relative;
}

.product-header {
  text-align: center;
  margin-bottom: 40px;
}

.main-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
}

.sub-title {
  font-size: 16px;
  color: #666;
}

.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  min-height: 500px;
}

/* 加载中容器样式 */
.loading-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  grid-column: 1 / -1;
  color: #21ab4b;
  font-size: 12px;
}

/* 无产品时的提示样式 */
.no-product {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  color: #909399;
  grid-column: 1 / -1;
}

/* 无产品时的图标样式 */
.no-product i {
  font-size: 60px;
  margin-bottom: 20px;
  color: #dcdfe6;
}

/* 无产品时的主提示文字样式 */
.no-product p {
  font-size: 18px;
  margin-bottom: 10px;
}

/* 无产品时的次要提示文字样式 */
.no-product .sub-tip {
  font-size: 14px;
  color: #c0c4cc;
}

.product-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 225px;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.product-info {
  padding: 20px;
}

.product-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.product-title h2 {
  font-size: 18px;
  color: #333;
  margin: 0;
}

.product-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
}

.financial-support {
  background-color: #21ab4b;
}

.high-amount {
  background-color: #409eff;
}

.low-rate {
  background-color: #e6a23c;
}

.tech-support {
  background-color: #909399;
}

.product-features {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.feature-item {
  text-align: center;
}

.feature-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

.feature-value {
  font-size: 16px;
  color: #c81d1d;
  font-weight: bold;
}

.product-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  height: 42px;
  overflow: hidden;
  margin-bottom: 15px;
}

.product-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.apply-btn {
  background-color: #21ab4b;
  border-color: #21ab4b;
}

.apply-btn:hover {
  background-color: #24bb51;
  border-color: #24bb51;
}

.detail-link {
  color: #666;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.detail-link:hover {
  color: #24bb51;
}

.detail-link i {
  margin-left: 5px;
}

.pagination-container .el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>